import { useMediaQueryHelper } from 'app/RuangGTKHomepageV3/hooks/useMediaQueryHelper'
import { useTogglesStore } from 'stores/toggles'

/**
 * Controls whether the desktop responsive layout is active for /ide-praktik pages.
 *
 * Driven by the Toggle SDK key 'ide-praktik-desktop-view-enabled'.
 * - false (default): always renders mobile layout
 * - true: uses actual viewport — desktop layout activates at ≥768px
 */
export const useIdePraktikDesktopView = () => {
  const { isDesktop: isDesktopViewport } = useMediaQueryHelper()
  const isIdePraktikDesktopEnabled = useTogglesStore(
    (state) => state.toggles?.['ide-praktik-desktop-view-enabled']
  )

  const isDesktop = isIdePraktikDesktopEnabled === true && isDesktopViewport

  return { isDesktop }
}
